import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getAnchorMission = createAsyncThunk(
  'AnchorTask/getAnchorMission',
  async (e, store: any) => {
    const resp = await http.post('/live/activity/anchor_mission', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
interface IRule {
  level: number
  gift_coins: number
  reward_coins: number
}

// 固定时间|日周期|周周期|月周期
export enum ACT_PERIOD {
  fixed = 1,
  daily,
  weekly,
  monthly,
}

const initialState: {
  err_msg: string
  rule_list: Array<IRule>
  activity_name: string
  activity_st_str: string
  activity_et_str: string
  count_down: number
  cur_reward: number
  cur_income: number
  cur_level: number
  need_coins: number
  act_period: ACT_PERIOD
} = {
  err_msg: '',
  activity_name: '',
  rule_list: [
    // {
    //   level: 1,
    //   gift_coins: 20,
    //   reward_coins: 100,
    // },
    // {
    //   level: 2,
    //   gift_coins: 10,
    //   reward_coins: 50,
    // },
    // {
    //   level: 3,
    //   gift_coins: 20,
    //   reward_coins: 100,
    // },
    // {
    //   level: 4,
    //   gift_coins: 20,
    //   reward_coins: 100,
    // },
  ],
  activity_st_str: '',
  activity_et_str: '',
  count_down: 0, // 秒
  cur_reward: 0,
  cur_income: 0,
  cur_level: 0,
  need_coins: 0,
  act_period: ACT_PERIOD.fixed,
}
export const AnchorTaskSlice = createSlice({
  name: 'AnchorTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAnchorMission.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      data.rule_list = data.rule_list?.sort((a, b) => a?.level - b?.level)
      Object.assign(state, data)
    })
  },
})
export default AnchorTaskSlice.reducer
